export default {
  auth: {
    isFetching: !!process.env.GATSBY_OPTIONS_LOAD_USER_DURING_INITIALIZATION,
    isLoggedIn: false,
    token: null,
  },
  cart: {
    data: {},
    isFetching: false,
    error: null,
    promoCode: {
      isFetching: false,
    },
  },
  catalog: {
    collections: [],
  },
  user: {
    data: {},
    referralIdentifier: null,
    subscriptions: [],
  },
  subscription: {
    data: {},
    isFetching: false,
    isLoaded: false,
    error: null,
  },
}
